export default "__VITE_ASSET____2w2ZjS__"